import React, { Component, Fragment } from "react";
import "../../resources/explore.css";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import PostList from "./PostList";
import NewPost from "./NewPost";
import { Link, NavLink } from "react-router-dom";
import userService from "../../services/userService";
import { withSnackbar } from "./../../hocs/withSnackbar";
import { Tab, Tabs } from "@mui/material";
import { Link as MuiLink } from "@mui/material";
import { withRouter } from "react-router-dom";
import NotFound from "../NotFound";

class Explore extends Component {
  state = {
    topics: [],
    loadedTopics: false,
    posts: [],
    loadedPosts: false,
    topicNotFound: false,
  };

  componentDidMount = async () => {
    const selectedCategory = this.props.match.params.category;
    this.getTopics(async () => {
      await this.getPosts(selectedCategory, true);
    }, true);
  };

  setSelectedTopic = (topic) => {
    this.setState({
      currentTopic: topic,
    });
  };

  getCurrentCategory = () => {
    const selectedCategory = this.props.match.params.category;
    if (selectedCategory) {
      const currentCategory = this.state.topics.find(
        (topic) => topic.name.toLowerCase() == selectedCategory.toLowerCase()
      );
      return currentCategory;
    }
    return null;
  };

  didCreateNewPost = async (categoryId) => {
    const selectedCategory = this.props.match.params.category;
    const currentCategory = this.getCurrentCategory();
    if (currentCategory) {
      if (currentCategory.id == categoryId) {
        // only refresh current list of posts if the user posted on the current category
        await this.getPosts(currentCategory.name);
      }
    } else if (!selectedCategory) {
      // all page
      await this.getPosts();
    }
  };

  getTopics = async (callback, checkExistence) => {
    const topicsResponse = await postService.getTopics();
    const topics = topicsResponse.data.data;
    const selectedCategory = this.props.match.params.category;
    if (checkExistence) {
      if (selectedCategory) {
        const topic = topics.find((topic) => topic.name == selectedCategory);
        if (!topic) {
          this.setState({
            topicNotFound: true,
          });
        }
      }
    }
    this.setState({ loadedTopics: true, topics }, callback);
  };

  getPosts = async (name, rateLimit = false) => {
    if (rateLimit) {
      this.setState({ loadedPosts: false });
    }

    const loadPosts = async () => {
      const { topics } = this.state;
      const lowercaseName = name?.toLowerCase();
      const topic = topics.find(
        (topic) => topic.name.toLowerCase() == lowercaseName
      );
      const { onCategoryChange } = this.props;
      onCategoryChange(topic);
      const postsResponse = await postService.getPosts(topic?.id);
      const posts = postsResponse.data.data;
      this.setState({ loadedPosts: true, posts });
    };

    if (rateLimit) {
      setTimeout(loadPosts, 500);
    } else {
      loadPosts();
    }
  };

  handleCategoryChange = async (name) => {
    await this.getPosts(name, true);
  };

  handleDelete = async () => {
    const currentCategory = this.getCurrentCategory();
    this.props.showMessage("Deleted post");
    await this.getPosts(currentCategory?.name);
  };

  render() {
    const { loadedPosts, loadedTopics, posts, topics, topicNotFound } =
      this.state;

    if (topicNotFound) {
      return <NotFound />;
    }

    const { history } = this.props;
    const currentCategory = this.getCurrentCategory();
    const currentUser = userService.getCurrentUser();
    return (
      <div className="post-section-content">
        {!loadedTopics ? (
          <div style={{ padding: "0 20px", paddingTop: 10 }}>
            <CircularLoadingScreen thickness={5} />
          </div>
        ) : (
          <Fragment>
            <div style={{ padding: "0 40px", paddingTop: 10 }}>
              <h1 className="heading" style={{ marginTop: 0 }}>
                Explore
              </h1>
            </div>
            <div className="topics-container">
              <div className="topics">
                <Tabs
                  value={history.location.pathname}
                  onChange={(event, newValue) => {
                    history.push(newValue);
                    this.handleCategoryChange(newValue.split("/")[2] || "");
                  }}
                  variant="scrollable"
                  scrollButtons
                >
                  {/* <NavLink
                        to="/explore"
                        exact
                        onClick={() => this.handleCategoryChange()}
                      >
                        <Tab label="All"/>
                      </NavLink> */}
                  <Tab label="All" value="/explore" className="topic" />
                  {topics.map((topic) => (
                    // <NavLink
                    //   to={"/explore/" + topic.name}
                    //   key={topic.id}
                    //   onClick={() => this.handleCategoryChange(topic.name)}
                    // >
                    //   <Tab key={topic.id} label={topic.name}/>
                    // </NavLink>
                    <Tab
                      key={topic.id}
                      label={topic.name}
                      value={"/explore/" + topic.name}
                      className="topic"
                    />
                  ))}
                </Tabs>
              </div>
            </div>
          </Fragment>
        )}
        <div className="posts">
          {!loadedPosts ? (
            <CircularLoadingScreen thickness={5} />
          ) : (
            <Fragment>
              {(currentUser.isAdmin ||
                currentCategory == null ||
                (!currentUser.isAdmin && !currentCategory.adminOnly)) && (
                <NewPost
                  topics={this.state.topics}
                  currentTopic={currentCategory}
                  key={currentCategory?.id || ""}
                  onCreatedNewPost={this.didCreateNewPost}
                />
              )}
              <PostList
                posts={posts}
                onDelete={this.handleDelete}
                noPostsError="No posts in this category"
              />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(withSnackbar(Explore));
